// extracted by mini-css-extract-plugin
module.exports = {"TeamMember":"TeamMember_TeamMember__1W8dd","Avatar":"TeamMember_Avatar__1ZcUo","Dialog":"TeamMember_Dialog__2_lVT"};